import React, { Component } from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {updateDataUser} from "../js/actions/index";
import "./menuSondas.scss";

function mapStateToProps(state){
	return({
		datosUser: state.login.user,
		token: state.login.token,
	});
}
function mapDispatchToProps(dispatch){
	return {
		updateDataUser:(field,value)=>dispatch(updateDataUser({field,value}))
	};
}
class MenuSondas extends Component{
	
	valida = "snd_4";
	sondasRandom = [];
	state={
		elegida:"",
		error:"",
	}
	UNSAFE_componentWillMount(){
		let sondas=[
			{
				id:"snd_1",
				imagen: "Sonda-Convex-5-2-MHz.png",
				texto: "Sonda Covex 5-2 Mhz",
			},
			{
				id:"snd_2",
				imagen: "Sonda-Intracavitaria-8-5-MHz.png",
				texto: "Sonda Intracavitaria 8 - 5 Mhz",
			},
			{
				id:"snd_3",
				imagen: "Sonda-Lineal-10-5-MHz.png",
				texto: "Sonda Lineal 10 - 5 Mhz",
			},
			{
				id:"snd_4",
				imagen: "Sonda-Lineal-13-6-MHz.png",
				texto: "Sonda Lineal 13 6 Mhz",
			},
			{
				id:"snd_5",
				imagen: "Sonda-Transesofagica-2-8-MHz.png",
				texto: "Sonda Transesofagica 2 8 Mhz",
			},
		];
		while(sondas.length > 0){
			let numSonda = Math.floor(Math.random()*sondas.length);
			let sondaRandom = sondas.splice(numSonda,1);
			this.sondasRandom = this.sondasRandom.concat(sondaRandom);
		}
	}
	
	render(){
		let menuSondas = this.sondasRandom.map((item) =>{
			let clase = "sondaElegir";
			if(this.state.elegida === item.id) clase += " elegida";
			return <div key={item.id} className={clase} onClick={() => {
				this.setState({elegida:item.id,error:""});
			}}><img alt={"Opción sonda"+item.id} src={"content/sondas/"+item.imagen}/></div>;
		});
		return (<div className="menuSondas">
			<h1>selección de la sonda</h1>
			<p>Seleccione la sonda <b>lineal</b> de <b>13-6 MHZ</b> específica para la exploración de tejidos blandos superficiales</p>
			<p>El resto de sondas no son apropiadas para la exploración musculoesquelética</p>
			{menuSondas}
			<div className="error">{this.state.error}</div>
			<button onClick={()=>{
				if(this.state.elegida === "")this.setState({error:"seleccione una sonda"});
				else if(this.state.elegida === this.valida)this.props.updateDataUser("sondasVistas",true);
				else this.setState({error:"selección erronea, inténtelo de nuevo"});
			}}>continuar</button>
		</div>);
	}
}
MenuSondas.propTypes = {
	datosUser:PropTypes.object,
	token:PropTypes.string,
	updateDataUser:PropTypes.func,
};

export default connect(mapStateToProps,mapDispatchToProps)(MenuSondas);